<template>
  <div
    class="switch"
    v-on="$listeners"
  >
    <label
      class="switch__label"
      :for="fieldId"
      v-text="label"
    />
    <input
      :id="fieldId"
      v-model="enabled"
      class="switch__checkbox"
      :name="fieldId"
      type="checkbox"
    >
    <div
      class="switch__bar"
      :class="{'switch__bar--enabled': enabled}"
      @click="enabled = !enabled"
    >
      <span
        class="switch__slider switch__slider--round"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'TgFormSwitch',

  props: {
    id: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      required: true,
    },
    value: {
      type: Boolean,
      required: false,
      default: true,
    },
  },

  data () {
    return {
      enabled: this.value,
    };
  },

  computed: {
    fieldId () {
      if (this.id === null) {
        return `switch-slider-${new Date().toISOString()}`;
      }

      return this.id;
    },
  },

  watch: {
    value (enabled) {
      this.enabled = enabled;
    },
    enabled (enabled) {
      this.$emit('input', enabled);
    },
  },
};
</script>

<style scoped>
  .switch {
    display: inline-block;
  }

  .switch__label {
    font-size: .812rem;
    line-height: 1.125rem;
    display: inline-block;
    position: relative;
    top: -1px;
    margin: 0;
    cursor: pointer;
  }

  .switch__checkbox {
    display: none;
  }

  .switch__bar {
    position: relative;
    display: inline-block;
    width: 2.2rem;
    height: 1.125rem;
    background-color: #ccc;
    border-radius: .562rem;
    top: 2px;
    margin-left: .5rem;
    cursor: pointer;
  }

  .switch__bar--enabled {
    background-color: var(--primary);
  }

  .switch__slider {
    position: absolute;
    height: 1rem;
    width: 1rem;
    top: 1px;
    left: 1px;
    background-color: #fff;
    border-radius: 50%;
    transition: all .4s;
  }

  .switch__bar--enabled .switch__slider {
    left: calc(1.2rem - 1px);
  }

  .switch__slider--round {
    border-radius: 2rem;
  }

</style>
